import React from 'react' 
import {Box, CircularProgress} from '@mui/material';


export default function GradientCircularProgress() {
    return (
      <Box sx={{ position: 'relative', justifyContent: 'center', margin: '15px auto'}}>
        <svg width={0} height={0}>
          <defs>
            <linearGradient id="my_gradient" x1="0%" y1="0%" x2="0%" y2="100%">
              <stop offset="0%" stopColor="#f4a211" />
              <stop offset="100%" stopColor="#050A44" />
            </linearGradient>
          </defs>
        </svg>
        <CircularProgress 
      
        sx={{ 'svg circle': { stroke: 'url(#my_gradient)' }, animationDuration: '2500ms'}}  
        size={40}/>
         <Box
          sx={{
            top: 0,
            left: 0,
            bottom: 0,
            right: 0,
            position: 'absolute',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
          }}
        >
        </Box>
        </Box>
    );
    }